import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { DeleteReactionEmojiPayload } from '@sdk/messages/types/apiTypes';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useRemoveReaction = () => {
  const { updateReactions } = useConversationQueryCache();
  const { reactions } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async (payload: DeleteReactionEmojiPayload) => {
      const result = await reactions.deleteReactionEmoji(payload);

      return result.data;
    },
    onSuccess: (reactions, payload) => {
      updateReactions(payload.conversationId, payload.messageId, reactions);
    },
  });

  return mutation;
};
